import IntroductionPage from './introduction/Page'
import TrainerToolkitPage from './trainer-toolkit/Page'

export const Pages = {
  'introduction': IntroductionPage,
  'trainer-toolkit': TrainerToolkitPage,
}



// WEBPACK FOOTER //
// ./src/content/pages/index.js